import { useState } from "react";
import { Link } from "react-router-dom";
import ProfileChangePhoneVerify from "./ProfileChangePhoneVerify";

const ProfileChangePhone = ({
  successIcon,
  failIcon,
  close,
  onUpdatePhoneNumber,
}) => {
  const [step, setStep] = useState("start");
  const [phone, setPhone] = useState("+");
  const [code, setCode] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const getIsDisabled = () => {
    if (isLoading) {
      return true
    } else if (phone.trim().length < 10) {
      return true
    } else {
      return false
    }
  }

  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    const isValid = /^[\d+]*$/.test(inputValue);

    if (isValid) {
      setPhone(inputValue);
    }
  };

  return (
    <section className="profile-change__popup">
      {step === "start" && (
        <>
          <h2 className="modal-window__title">Change Phone Number</h2>
          <form className="profile-change__form">
            <p className="profile-change__row">
              <label htmlFor="phone">Enter New Phone Number</label>
              <input
                type="text"
                id="phone"
                onInput={handleInputChange}
                value={phone}
                placeholder="Phone number"
                autoFocus
              />
            </p>
            <p className="profile-change__tip profile-change__tip--big">
              We've sent a text message to the number below. By continuing, you
              authorize TwoTwentyK to continue to send text messages for
              identity verification, offers and other information. Message/data
              rates apply. Terms and conditions and Privacy Policy can be found
              at <Link to='/privacies/terms-of-use'>Terms & Conditions</Link> and <Link to='/privacies/privacy-policy'>Privacy Policy</Link>
            </p>
            <button
              type="button"
              className="profile-change__form-submit"
              disabled={getIsDisabled()}
              onClick={() => onUpdatePhoneNumber(phone, setStep, setIsLoading)}
            >
              Continue
            </button>
          </form>
        </>
      )}
      {step === "verification" && (
        <ProfileChangePhoneVerify code={code} setCode={setCode} phone={phone} setStep={setStep} />
      )}

      {step === "success" && (
        <>
          <header className="modal-window__header">
            <img src={successIcon} className="modal-window__icon" alt="" />
            <h5 className="modal-window__title">Success!</h5>
            <p className="modal-window__info">
              Your phone number was updated successfully!
            </p>
          </header>
          <footer className="modal-window__footer">
            <button className="modal-window__footer-submit" onClick={close}>
              Done
            </button>
          </footer>
        </>
      )}

      {step === "fail" && (
        <>
          <header className="modal-window__header">
            <img src={failIcon} className="modal-window__icon" alt="" />
            <h5 className="modal-window__title">Something went wrong</h5>
            <p className="modal-window__info">Please, try again later</p>
          </header>
          <footer className="modal-window__footer">
            <button className="modal-window__footer-submit" onClick={close}>
              Done
            </button>
          </footer>
        </>
      )}
    </section>
  );
};

export default ProfileChangePhone;
